/* eslint-disable no-tabs */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';

class Picto extends React.PureComponent {
  render() {
    const { classes, name, disabled, width, height, className } = this.props;
    return (
      <svg viewBox="0 0 90 90" width={width} height={height} className={className}>
        <g
          className={`${name === 'foncier' ? classes.show : classes.hide} ${
            disabled ? classes.transparent : classes.opaque
          }`}
        >
          <ellipse style={{ fill: '#19926E' }} cx="45" cy="45" rx="45" ry="45" />
          <path style={{ fill: '#FBC142' }} d="M46,74.8L8.3,52.1L46,29.3l37.7,22.8L46,74.8z" />
          <path style={{ fill: '#C6D86B' }} d="M46,27.5l4.4-2.7l4.4-2.7L46,16.7l-8.9,5.4l4.4,2.7L46,27.5z" />
          <path
            style={{ fill: '#C6D86B' }}
            d="M46.9,28.1l4.4,2.7l4.4,2.7l4.4-2.7l4.4-2.7l-8.9-5.4l-4.4,2.7L46.9,28.1z"
          />
          <path style={{ fill: '#C6D86B' }} d="M64.7,40.1l-8.9-5.4l-8.9,5.4l8.9,5.4L64.7,40.1z" />
          <path
            style={{ fill: '#C6D86B' }}
            d="M36.1,33.5l4.4-2.7l4.4-2.7l-4.4-2.7l-4.4-2.7l-8.9,5.4l4.4,2.7L36.1,33.5z"
          />
          <path
            style={{ fill: '#C6D86B' }}
            d="M50.4,36.8l4.4-2.7l-4.4-2.7L46,28.7l-4.4,2.7l-4.4,2.7l4.4,2.7l4.4,2.7L50.4,36.8z"
          />
          <path
            style={{ fill: '#C6D86B' }}
            d="M56.8,34.1l4.4,2.7l4.4,2.7l4.4-2.7l4.4-2.7l-8.9-5.4l-4.4,2.7L56.8,34.1z"
          />
          <path style={{ fill: '#C6D86B' }} d="M27.2,40.1l8.9,5.4l8.9-5.4l-8.9-5.4L27.2,40.1z" />
          <path
            style={{ fill: '#C6D86B' }}
            d="M26.3,39.5l4.4-2.7l4.4-2.7l-4.4-2.7l-4.4-2.7l-8.9,5.4l4.4,2.7L26.3,39.5z"
          />
          <path
            style={{ fill: '#C6D86B' }}
            d="M46,51.5l4.4-2.7l4.4-2.7l-4.4-2.7L46,40.7l0,0l-4.4,2.7l-4.4,2.7l4.4,2.7L46,51.5z"
          />
          <path
            style={{ fill: '#C6D86B' }}
            d="M55.8,46.6l-4.4,2.7L46.9,52l4.4,2.7l4.4,2.7l8.9-5.4l-4.4-2.7L55.8,46.6z"
          />
          <path style={{ fill: '#C6D86B' }} d="M66.7,40.1l8.9,5.4l8.9-5.4l-8.9-5.4L66.7,40.1z" />
          <path style={{ fill: '#C6D86B' }} d="M16.4,34.7l-8.9,5.4l8.9,5.4l8.9-5.4L16.4,34.7z" />
          <path
            style={{ fill: '#C6D86B' }}
            d="M65.7,40.6l-4.4,2.7l-4.4,2.7l4.4,2.7l4.4,2.7l8.9-5.4l-4.4-2.7L65.7,40.6z"
          />
          <path style={{ fill: '#C6D86B' }} d="M46,52.6l-4.4,2.7L37.1,58l8.9,5.4l8.9-5.4l-4.4-2.7L46,52.6z" />
          <path style={{ fill: '#C6D86B' }} d="M35.2,46l-6.6-4l-2.3-1.4l-4.4,2.7L17.4,46l8.9,5.4l6.4-3.9L35.2,46z" />
          <path style={{ fill: '#C6D86B' }} d="M45,52l-4.4-2.7l-4.4-2.7l-2.7,1.6L27.2,52l8.9,5.4l4.4-2.7L45,52z" />
          <path
            style={{ fill: '#19926E', stroke: '#19926E', strokeMiterlimit: 10 }}
            d="M76.3,34l-0.8-0.5l-9.7-5.9l-9.1-5.5l-0.2-0.1l-0.7-0.4
		L46,15.7l-9.8,6l-0.7,0.4l-0.2,0.1l-9.1,5.5l-9.7,5.9L15.7,34l-0.2,0.1L5.7,40l9.8,6l10.7,6.5l9.8,6l9.8,6l9.8-6l9.8-6L76.4,46
		l9.8-6L76.3,34L76.3,34z M74.6,34.1l-4.5,2.7l-4.5,2.7l-4.5-2.7l-4.5-2.7l4.5-2.7l4.5-2.7L74.6,34.1z M45.1,40l-8.9,5.4L27.2,40
		l8.9-5.4L45.1,40z M37,34.1l4.5-2.7l4.5-2.7l4.5,2.7l4.5,2.7l-4.5,2.7L46,39.5l-4.5-2.7L37,34.1z M41.5,43.3l4.5-2.7l0,0l4.5,2.7
		l4.5,2.7l-4.5,2.7L46,51.4l-4.5-2.7L37,46L41.5,43.3z M46.9,40l8.9-5.4l8.9,5.4l-8.9,5.4L46.9,40z M64.7,28.1l-4.5,2.7l-4.5,2.7
		l-4.4-2.7l-4.5-2.7l4.5-2.7l4.5-2.7L64.7,28.1z M46,16.8l8.9,5.4l-4.5,2.7L46,27.6l-4.5-2.7L37,22.2L46,16.8z M36.1,22.7l4.5,2.7
		l4.5,2.7l-4.5,2.7l-4.5,2.7l-4.5-2.7l-4.5-2.7L36.1,22.7z M26.3,28.7l4.5,2.7l4.5,2.7l-4.5,2.7l-4.5,2.7l-4.5-2.7l-4.5-2.7
		L26.3,28.7z M7.5,40l8.9-5.4l8.9,5.4l-8.9,5.4L7.5,40z M17.3,46l4.5-2.7l4.5-2.7l2.3,1.4l6.6,4l-2.5,1.5l-6.4,3.9L17.3,46z
		 M27.2,51.9l6.3-3.8l2.7-1.6l4.5,2.7l4.5,2.7l-4.5,2.7l-4.5,2.7L27.2,51.9z M46,63.3L37,57.9l4.5-2.7l4.5-2.7l4.5,2.7l4.5,2.7
		L46,63.3z M55.8,57.3l-4.5-2.7l-4.5-2.7l4.5-2.7l4.5-2.7l4.5,2.7l4.4,2.7L55.8,57.3z M65.7,51.4l-4.5-2.7L56.7,46l4.5-2.7l4.5-2.7
		l4.5,2.7l4.5,2.7L65.7,51.4z M75.5,45.4L66.6,40l8.9-5.4l8.9,5.4L75.5,45.4z"
          />
        </g>
        <g
          className={`${name === 'foncier' ? classes.show : classes.hide} ${
            disabled ? `${classes.opaque} disabled` : classes.transparent
          }`}
        >
          <ellipse style={{ fill: '#6A6A6A' }} cx="45" cy="45" rx="45" ry="45" />
          <path style={{ fill: '#C4C4C4' }} d="M46,74.8L8.3,52.1L46,29.3l37.7,22.8L46,74.8z" />
          <path style={{ fill: '#C7C7C7' }} d="M46,27.5l4.4-2.7l4.4-2.7L46,16.7l-8.9,5.4l4.4,2.7L46,27.5z" />
          <path
            style={{ fill: '#C7C7C7' }}
            d="M46.9,28.1l4.4,2.7l4.4,2.7l4.4-2.7l4.4-2.7l-8.9-5.4l-4.4,2.7L46.9,28.1z"
          />
          <path style={{ fill: '#C7C7C7' }} d="M64.7,40.1l-8.9-5.4l-8.9,5.4l8.9,5.4L64.7,40.1z" />
          <path
            style={{ fill: '#C7C7C7' }}
            d="M36.1,33.5l4.4-2.7l4.4-2.7l-4.4-2.7l-4.4-2.7l-8.9,5.4l4.4,2.7L36.1,33.5z"
          />
          <path
            style={{ fill: '#C7C7C7' }}
            d="M50.4,36.8l4.4-2.7l-4.4-2.7L46,28.7l-4.4,2.7l-4.4,2.7l4.4,2.7l4.4,2.7L50.4,36.8z"
          />
          <path
            style={{ fill: '#C7C7C7' }}
            d="M56.8,34.1l4.4,2.7l4.4,2.7l4.4-2.7l4.4-2.7l-8.9-5.4l-4.4,2.7L56.8,34.1z"
          />
          <path style={{ fill: '#C7C7C7' }} d="M27.2,40.1l8.9,5.4l8.9-5.4l-8.9-5.4L27.2,40.1z" />
          <path
            style={{ fill: '#C7C7C7' }}
            d="M26.3,39.5l4.4-2.7l4.4-2.7l-4.4-2.7l-4.4-2.7l-8.9,5.4l4.4,2.7L26.3,39.5z"
          />
          <path
            style={{ fill: '#C7C7C7' }}
            d="M46,51.5l4.4-2.7l4.4-2.7l-4.4-2.7L46,40.7l0,0l-4.4,2.7l-4.4,2.7l4.4,2.7L46,51.5z"
          />
          <path
            style={{ fill: '#C7C7C7' }}
            d="M55.8,46.6l-4.4,2.7L46.9,52l4.4,2.7l4.4,2.7l8.9-5.4l-4.4-2.7L55.8,46.6z"
          />
          <path style={{ fill: '#C7C7C7' }} d="M66.7,40.1l8.9,5.4l8.9-5.4l-8.9-5.4L66.7,40.1z" />
          <path style={{ fill: '#C7C7C7' }} d="M16.4,34.7l-8.9,5.4l8.9,5.4l8.9-5.4L16.4,34.7z" />
          <path
            style={{ fill: '#C7C7C7' }}
            d="M65.7,40.6l-4.4,2.7l-4.4,2.7l4.4,2.7l4.4,2.7l8.9-5.4l-4.4-2.7L65.7,40.6z"
          />
          <path style={{ fill: '#C7C7C7' }} d="M46,52.6l-4.4,2.7L37.1,58l8.9,5.4l8.9-5.4l-4.4-2.7L46,52.6z" />
          <path style={{ fill: '#C7C7C7' }} d="M35.2,46l-6.6-4l-2.3-1.4l-4.4,2.7L17.4,46l8.9,5.4l6.4-3.9L35.2,46z" />
          <path style={{ fill: '#C7C7C7' }} d="M45,52l-4.4-2.7l-4.4-2.7l-2.7,1.6L27.2,52l8.9,5.4l4.4-2.7L45,52z" />
          <path
            style={{ fill: '#6A6A6A', stroke: '#6A6A6A', strokeMiterlimit: 10 }}
            d="M76.3,34l-0.8-0.5l-9.7-5.9l-9.1-5.5l-0.2-0.1l-0.7-0.4
		L46,15.7l-9.8,6l-0.7,0.4l-0.2,0.1l-9.1,5.5l-9.7,5.9L15.7,34l-0.2,0.1L5.7,40l9.8,6l10.7,6.5l9.8,6l9.8,6l9.8-6l9.8-6L76.4,46
		l9.8-6L76.3,34L76.3,34z M74.6,34.1l-4.5,2.7l-4.5,2.7l-4.5-2.7l-4.5-2.7l4.5-2.7l4.5-2.7L74.6,34.1z M45.1,40l-8.9,5.4L27.2,40
		l8.9-5.4L45.1,40z M37,34.1l4.5-2.7l4.5-2.7l4.5,2.7l4.5,2.7l-4.5,2.7L46,39.5l-4.5-2.7L37,34.1z M41.5,43.3l4.5-2.7l0,0l4.5,2.7
		l4.5,2.7l-4.5,2.7L46,51.4l-4.5-2.7L37,46L41.5,43.3z M46.9,40l8.9-5.4l8.9,5.4l-8.9,5.4L46.9,40z M64.7,28.1l-4.5,2.7l-4.5,2.7
		l-4.4-2.7l-4.5-2.7l4.5-2.7l4.5-2.7L64.7,28.1z M46,16.8l8.9,5.4l-4.5,2.7L46,27.6l-4.5-2.7L37,22.2L46,16.8z M36.1,22.7l4.5,2.7
		l4.5,2.7l-4.5,2.7l-4.5,2.7l-4.5-2.7l-4.5-2.7L36.1,22.7z M26.3,28.7l4.5,2.7l4.5,2.7l-4.5,2.7l-4.5,2.7l-4.5-2.7l-4.5-2.7
		L26.3,28.7z M7.5,40l8.9-5.4l8.9,5.4l-8.9,5.4L7.5,40z M17.3,46l4.5-2.7l4.5-2.7l2.3,1.4l6.6,4l-2.5,1.5l-6.4,3.9L17.3,46z
		 M27.2,51.9l6.3-3.8l2.7-1.6l4.5,2.7l4.5,2.7l-4.5,2.7l-4.5,2.7L27.2,51.9z M46,63.3L37,57.9l4.5-2.7l4.5-2.7l4.5,2.7l4.5,2.7
		L46,63.3z M55.8,57.3l-4.5-2.7l-4.5-2.7l4.5-2.7l4.5-2.7l4.5,2.7l4.4,2.7L55.8,57.3z M65.7,51.4l-4.5-2.7L56.7,46l4.5-2.7l4.5-2.7
		l4.5,2.7l4.5,2.7L65.7,51.4z M75.5,45.4L66.6,40l8.9-5.4l8.9,5.4L75.5,45.4z"
          />
        </g>
        <g
          className={`${name === 'matiere' ? classes.show : classes.hide} ${
            disabled ? classes.transparent : classes.opaque
          }`}
        >
          <ellipse style={{ fill: '#FBC142' }} cx="45" cy="45" rx="45" ry="45" />
          <circle style={{ fill: '#F29FC5' }} cx="26.5" cy="34.9" r="8.6" />
          <ellipse style={{ fill: '#F29FC5' }} cx="37.4" cy="32.3" rx="11.1" ry="11.1" />
          <path
            style={{ fill: '#F29FC5' }}
            d="M54.1,29.4c-3.9,0-7.1,3.2-7.1,7.1c0,0,0,0,0,0h14.1C61.2,32.6,58,29.4,54.1,29.4
		C54.1,29.4,54.1,29.4,54.1,29.4z"
          />
          <path
            style={{ fill: '#A51367' }}
            d="M62.8,36.2l-48-0.1c-0.9-0.1-1.7,0.5-1.8,1.3c-0.1,0.9,0.5,1.7,1.3,1.8c0,0,0,0,0.1,0h0.7l11.4,14.4
		c1.9,0.9,3.5,2.2,4.7,3.9l23-6.7c1.7-0.5,3.1-1.7,4-3.2l4.3-8.2h0.3c0.9,0,1.6-0.7,1.6-1.6C64.4,36.9,63.7,36.2,62.8,36.2
		L62.8,36.2z M45.1,50L41.5,51c-0.6,0.2-1.2,0-1.4-0.6s0-1.2,0.6-1.4c0.1,0,0.1,0,0.2-0.1l3.6-1.1c0.6-0.2,1.2,0.2,1.4,0.7
		S45.7,49.8,45.1,50L45.1,50L45.1,50z M57.2,42.3l-2.3,4.5c-0.1,0.3-0.4,0.5-0.7,0.5l-4.6,1.4c-0.6,0.1-1.2-0.2-1.3-0.8
		c-0.1-0.6,0.2-1.1,0.7-1.3l4.2-1.2l2.2-4.1c0.3-0.5,1-0.7,1.5-0.5C57.3,41.1,57.5,41.7,57.2,42.3L57.2,42.3z"
          />
          <path
            style={{ fill: '#A51367' }}
            d="M79.8,22.5c-4.6,0.8-8.5,4-10.1,8.4l-3.6,14.6c-1.2,3-3.7,5.4-6.8,6.2l-28.9,8.4
		c-2.4-4.5-7.7-6.6-12.5-4.8c-5.2,2-7.8,7.8-5.8,13c2,5.2,7.8,7.8,13,5.8c3.9-1.5,6.4-5.2,6.5-9.4c0-0.5,0-1.1-0.1-1.6l9.8-2.8
		l4.8,9.6c0.7,2,3,3.1,5,2.4c1.4-0.5,2.4-1.7,2.6-3.1l1.8-13l4.8-1.4c4.1-1.1,7.4-4.2,8.9-8.1L72.6,32c1.3-3.3,4.2-5.7,7.7-6.4
		c0.8-0.1,1.3-0.8,1.3-1.5V24c0-0.5-0.2-0.9-0.6-1.2C80.7,22.5,80.2,22.4,79.8,22.5L79.8,22.5z M21.4,70.9c-3.4,0-6.2-2.8-6.2-6.2
		c0-3.4,2.8-6.2,6.2-6.2c3.4,0,6.2,2.8,6.2,6.2C27.6,68.1,24.8,70.9,21.4,70.9z M51.3,68.8c-0.2,0.9-1.1,1.5-2,1.3
		c-0.6-0.1-1.1-0.5-1.3-1.1c0-0.1,0-0.1-0.1-0.1l-4.7-9.3l9.7-2.8L51.3,68.8z"
          />
          <ellipse style={{ fill: '#A51367' }} cx="21.4" cy="64.7" rx="4" ry="4" />
        </g>
        <g
          className={`${name === 'matiere' ? classes.show : classes.hide} ${
            disabled ? `${classes.opaque} disabled` : classes.transparent
          }`}
        >
          <ellipse style={{ fill: '#C4C4C4' }} cx="45" cy="45" rx="45" ry="45" />
          <circle style={{ fill: '#BCBCBC' }} cx="26.5" cy="34.9" r="8.6" />
          <ellipse style={{ fill: '#BCBCBC' }} cx="37.4" cy="32.3" rx="11.1" ry="11.1" />
          <path
            style={{ fill: '#BCBCBC' }}
            d="M54.1,29.4c-3.9,0-7.1,3.2-7.1,7.1c0,0,0,0,0,0h14.1C61.2,32.6,58,29.4,54.1,29.4
		C54.1,29.4,54.1,29.4,54.1,29.4z"
          />
          <path
            style={{ fill: '#484848' }}
            d="M62.8,36.2l-48-0.1c-0.9-0.1-1.7,0.5-1.8,1.3c-0.1,0.9,0.5,1.7,1.3,1.8c0,0,0,0,0.1,0h0.7l11.4,14.4
		c1.9,0.9,3.5,2.2,4.7,3.9l23-6.7c1.7-0.5,3.1-1.7,4-3.2l4.3-8.2h0.3c0.9,0,1.6-0.7,1.6-1.6C64.4,36.9,63.7,36.2,62.8,36.2
		L62.8,36.2z M45.1,50L41.5,51c-0.6,0.2-1.2,0-1.4-0.6s0-1.2,0.6-1.4c0.1,0,0.1,0,0.2-0.1l3.6-1.1c0.6-0.2,1.2,0.2,1.4,0.7
		S45.7,49.8,45.1,50L45.1,50L45.1,50z M57.2,42.3l-2.3,4.5c-0.1,0.3-0.4,0.5-0.7,0.5l-4.6,1.4c-0.6,0.1-1.2-0.2-1.3-0.8
		c-0.1-0.6,0.2-1.1,0.7-1.3l4.2-1.2l2.2-4.1c0.3-0.5,1-0.7,1.5-0.5C57.3,41.1,57.5,41.7,57.2,42.3L57.2,42.3z"
          />
          <path
            style={{ fill: '#484848' }}
            d="M79.8,22.5c-4.6,0.8-8.5,4-10.1,8.4l-3.6,14.6c-1.2,3-3.7,5.4-6.8,6.2l-28.9,8.4
		c-2.4-4.5-7.7-6.6-12.5-4.8c-5.2,2-7.8,7.8-5.8,13c2,5.2,7.8,7.8,13,5.8c3.9-1.5,6.4-5.2,6.5-9.4c0-0.5,0-1.1-0.1-1.6l9.8-2.8
		l4.8,9.6c0.7,2,3,3.1,5,2.4c1.4-0.5,2.4-1.7,2.6-3.1l1.8-13l4.8-1.4c4.1-1.1,7.4-4.2,8.9-8.1L72.6,32c1.3-3.3,4.2-5.7,7.7-6.4
		c0.8-0.1,1.3-0.8,1.3-1.5V24c0-0.5-0.2-0.9-0.6-1.2C80.7,22.5,80.2,22.4,79.8,22.5L79.8,22.5z M21.4,70.9c-3.4,0-6.2-2.8-6.2-6.2
		c0-3.4,2.8-6.2,6.2-6.2c3.4,0,6.2,2.8,6.2,6.2C27.6,68.1,24.8,70.9,21.4,70.9z M51.3,68.8c-0.2,0.9-1.1,1.5-2,1.3
		c-0.6-0.1-1.1-0.5-1.3-1.1c0-0.1,0-0.1-0.1-0.1l-4.7-9.3l9.7-2.8L51.3,68.8z"
          />
          <ellipse style={{ fill: '#484848' }} cx="21.4" cy="64.7" rx="4" ry="4" />
        </g>
        <g
          className={`${name === 'energie' ? classes.show : classes.hide} ${
            disabled ? classes.transparent : classes.opaque
          }`}
        >
          <ellipse style={{ fill: '#00A3B4' }} cx="45" cy="45" rx="45" ry="45" />
          <path
            style={{ fill: '#FBC142' }}
            d="M63.6,37.1c0.4-0.4,0.3-1,0-1.3c-0.2-0.2-0.4-0.3-0.6-0.3H50.3c-0.3,0-0.5-0.2-0.6-0.5
		c0-0.1,0-0.2,0.1-0.3L61,16.8c0.3-0.5,0.3-1.2,0-1.7c-0.3-0.5-0.8-0.9-1.5-0.9H44.4c-0.6,0-1.2,0.3-1.5,0.9L26.4,47.4
		c-0.1,0.2-0.1,0.4,0,0.6c0.1,0.2,0.3,0.3,0.5,0.3h10.4c0.5,0,0.9,0.5,0.9,1c0,0.1,0,0.2-0.1,0.3L26.6,78.3c-0.1,0.1,0,0.3,0.1,0.4
		c0.1,0.1,0.3,0.1,0.4-0.1L63.6,37.1z"
          />
        </g>
        <g
          className={`${name === 'energie' ? classes.show : classes.hide} ${
            disabled ? `${classes.opaque} disabled` : classes.transparent
          }`}
        >
          <ellipse style={{ fill: '#747474' }} cx="45" cy="45" rx="45" ry="45" />
          <path
            style={{ fill: '#C4C4C4' }}
            d="M63.6,37.1c0.4-0.4,0.3-1,0-1.3c-0.2-0.2-0.4-0.3-0.6-0.3H50.3c-0.3,0-0.5-0.2-0.6-0.5
		c0-0.1,0-0.2,0.1-0.3L61,16.8c0.3-0.5,0.3-1.2,0-1.7c-0.3-0.5-0.8-0.9-1.5-0.9H44.4c-0.6,0-1.2,0.3-1.5,0.9L26.4,47.4
		c-0.1,0.2-0.1,0.4,0,0.6c0.1,0.2,0.3,0.3,0.5,0.3h10.4c0.5,0,0.9,0.5,0.9,1c0,0.1,0,0.2-0.1,0.3L26.6,78.3c-0.1,0.1,0,0.3,0.1,0.4
		c0.1,0.1,0.3,0.1,0.4-0.1L63.6,37.1z"
          />
        </g>
        <g
          className={`${name === 'eau' ? classes.show : classes.hide} ${
            disabled ? classes.transparent : classes.opaque
          }`}
        >
          <ellipse style={{ fill: '#C6D86B' }} cx="45" cy="45" rx="45" ry="45" />
          <ellipse style={{ fill: '#00A3B4' }} cx="45.2" cy="48.5" rx="24.2" ry="24" />

          <rect
            x="33.4"
            y="19.4"
            transform="matrix(0.7071 -0.7071 0.7071 0.7071 -8.8091 41.0606)"
            style={{ fill: '#00A3B4' }}
            width="23.6"
            height="23.6"
          />
          <path
            style={{
              fill: 'none',
              stroke: '#C6D86B',
              strokeWidth: 3,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="M59.8,58.6
		c-3.3,4.8-8.8,7.7-14.6,7.7"
          />
          <path
            style={{
              fill: 'none',
              stroke: '#C6D86B',
              strokeWidth: 3,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="M62.9,48.6
		c0,1.3-0.2,2.7-0.5,4"
          />
        </g>
        <g
          className={`${name === 'eau' ? classes.show : classes.hide} ${
            disabled ? `${classes.opaque} disabled` : classes.transparent
          }`}
        >
          <ellipse style={{ fill: '#C7C7C7' }} cx="45" cy="45" rx="45" ry="45" />
          <ellipse style={{ fill: '#747474' }} cx="45.2" cy="48.5" rx="24.2" ry="24" />

          <rect
            x="33.4"
            y="19.4"
            transform="matrix(0.7071 -0.7071 0.7071 0.7071 -8.8091 41.0606)"
            style={{ fill: '#747474' }}
            width="23.6"
            height="23.6"
          />
          <path
            style={{ fill: 'none', stroke: '#C7C7C7', strokeWidth: 3, strokeLinecap: 'round', strokeLinejoin: 'round' }}
            d="M59.8,58.6
		c-3.3,4.8-8.8,7.7-14.6,7.7"
          />
          <path
            style={{ fill: 'none', stroke: '#C7C7C7', strokeWidth: 3, strokeLinecap: 'round', strokeLinejoin: 'round' }}
            d="M62.9,48.6
		c0,1.3-0.2,2.7-0.5,4"
          />
        </g>
        <g
          className={`${name === 'chantier' ? classes.show : classes.hide} ${
            disabled ? classes.transparent : classes.opaque
          }`}
        >
          <ellipse style={{ fill: '#F29FC5' }} cx="45" cy="45" rx="45" ry="45" />
          <path
            style={{ fill: '#601C70' }}
            d="M41,70.8c1.4,0,2.6-1.2,2.6-2.6s-1.2-2.6-2.6-2.6s-2.6,1.2-2.6,2.6v0C38.4,69.6,39.6,70.8,41,70.8z"
          />
          <path style={{ fill: '#A51367' }} d="M32.4,56.7l-1.1,4.1h19.3l-1.1-4.1H32.4z" />
          <path
            style={{ fill: '#601C70' }}
            d="M27.5,70.8c1.4,0,2.6-1.2,2.6-2.6c0-1.4-1.2-2.6-2.6-2.6c-1.4,0-2.6,1.2-2.6,2.6l0,0
		C25,69.6,26.1,70.8,27.5,70.8z"
          />
          <path
            style={{ fill: '#601C70' }}
            d="M21,68.3c0,3.3,2.6,5.9,5.9,5.9H55c3.3-0.1,5.8-2.9,5.7-6.1c-0.1-3.1-2.6-5.6-5.7-5.7H26.9
		C23.6,62.4,21,65,21,68.3z M54.3,64.1c2.3,0,4.1,1.8,4.1,4.1c0,2.3-1.8,4.1-4.1,4.1c-2.3,0-4.1-1.8-4.1-4.1S52,64.1,54.3,64.1
		C54.3,64.1,54.3,64.1,54.3,64.1z M41,64.1c2.3,0,4.1,1.8,4.1,4.1c0,2.3-1.8,4.1-4.1,4.1c-2.3,0-4.1-1.8-4.1-4.1S38.7,64.1,41,64.1
		L41,64.1z M31.7,68.2c0,2.3-1.8,4.1-4.1,4.1c-2.3,0-4.1-1.8-4.1-4.1c0-2.3,1.8-4.1,4.1-4.1C29.9,64.1,31.7,66,31.7,68.2L31.7,68.2z
		"
          />
          <path
            style={{ fill: '#601C70' }}
            d="M54.4,70.8c1.4,0,2.6-1.2,2.6-2.6s-1.2-2.6-2.6-2.6s-2.6,1.2-2.6,2.6S53,70.8,54.4,70.8z"
          />
          <path
            style={{ fill: '#601C70' }}
            d="M23.9,23.2v11.5h8c0.4,0,0.7,0.3,0.7,0.7c0,0,0,0,0,0v5.7c0,1.1,0.9,1.9,1.9,1.9h5.2
		c1.1,0,1.9-0.9,1.9-1.9v-5.6L40,23.2H23.9z"
          />
          <path style={{ fill: '#601C70' }} d="M77.4,49.4l-6.6-26.6c-0.6,0.8-1.5,1.4-2.5,1.6l4.2,25L77.4,49.4z" />
          <path
            style={{ fill: '#A51367' }}
            d="M70,20.3c0-0.1,0-0.3,0-0.4l-0.1-0.4c-0.5-1.4-2-2.1-3.4-1.7c-1.4,0.5-2.1,2-1.7,3.4
		c0.5,1.4,2,2.1,3.4,1.7C69.3,22.5,70,21.5,70,20.3L70,20.3z"
          />
          <path
            style={{ fill: '#A51367' }}
            d="M43.3,36.4v4.8c0,1.9-1.5,3.4-3.4,3.4h-5.2c-1.9,0-3.4-1.5-3.4-3.4v-5h-7.7c-0.9,0-1.7,0.8-1.7,1.7
		v11.5h35.6v-9.1c0-1-0.7-1.8-1.6-1.9L43.3,36.4z"
          />
          <path style={{ fill: '#601C70' }} d="M63,20.7L48.2,35.6l6.5,1.1l11-12.5C64.3,23.7,63.2,22.3,63,20.7z" />
          <path
            style={{ fill: '#A51367' }}
            d="M21,55.1h37.8v-4.9c0-0.6-0.5-1.1-1.1-1.1h0H22.1c-0.6,0-1.1,0.5-1.1,1.1l0,0V55.1z"
          />
          <path
            style={{ fill: '#601C70' }}
            d="M40.2,18.9H23.4c-0.8-0.1-1.5,0.5-1.6,1.3v2.1c0.1,0.8,0.8,1.4,1.6,1.3h16.8
		c0.8,0.1,1.5-0.5,1.6-1.3v-2.1C41.7,19.4,41,18.8,40.2,18.9z"
          />
          <path style={{ fill: '#601C70' }} d="M66.1,64.5c6.4-0.4,11.5-5.7,11.5-12.2v-1.2H66.1V64.5z" />
        </g>
        <g
          className={`${name === 'chantier' ? classes.show : classes.hide} ${
            disabled ? `${classes.opaque} disabled` : classes.transparent
          }`}
        >
          <ellipse style={{ fill: '#BCBCBC' }} cx="45" cy="45" rx="45" ry="45" />
          <path
            style={{ fill: '#3A3A3A' }}
            d="M41,70.8c1.4,0,2.6-1.2,2.6-2.6s-1.2-2.6-2.6-2.6s-2.6,1.2-2.6,2.6v0C38.4,69.6,39.6,70.8,41,70.8z"
          />
          <path style={{ fill: '#484848' }} d="M32.4,56.7l-1.1,4.1h19.3l-1.1-4.1H32.4z" />
          <path
            style={{ fill: '#3A3A3A' }}
            d="M27.5,70.8c1.4,0,2.6-1.2,2.6-2.6c0-1.4-1.2-2.6-2.6-2.6c-1.4,0-2.6,1.2-2.6,2.6l0,0
		C25,69.6,26.1,70.8,27.5,70.8z"
          />
          <path
            style={{ fill: '#3A3A3A' }}
            d="M21,68.3c0,3.3,2.6,5.9,5.9,5.9H55c3.3-0.1,5.8-2.9,5.7-6.1c-0.1-3.1-2.6-5.6-5.7-5.7H26.9
		C23.6,62.4,21,65,21,68.3z M54.3,64.1c2.3,0,4.1,1.8,4.1,4.1c0,2.3-1.8,4.1-4.1,4.1c-2.3,0-4.1-1.8-4.1-4.1S52,64.1,54.3,64.1
		C54.3,64.1,54.3,64.1,54.3,64.1z M41,64.1c2.3,0,4.1,1.8,4.1,4.1c0,2.3-1.8,4.1-4.1,4.1c-2.3,0-4.1-1.8-4.1-4.1S38.7,64.1,41,64.1
		L41,64.1z M31.7,68.2c0,2.3-1.8,4.1-4.1,4.1c-2.3,0-4.1-1.8-4.1-4.1c0-2.3,1.8-4.1,4.1-4.1C29.9,64.1,31.7,66,31.7,68.2L31.7,68.2z
		"
          />
          <path
            style={{ fill: '#3A3A3A' }}
            d="M54.4,70.8c1.4,0,2.6-1.2,2.6-2.6s-1.2-2.6-2.6-2.6s-2.6,1.2-2.6,2.6S53,70.8,54.4,70.8z"
          />
          <path
            style={{ fill: '#3A3A3A' }}
            d="M23.9,23.2v11.5h8c0.4,0,0.7,0.3,0.7,0.7c0,0,0,0,0,0v5.7c0,1.1,0.9,1.9,1.9,1.9h5.2
		c1.1,0,1.9-0.9,1.9-1.9v-5.6L40,23.2H23.9z"
          />
          <path style={{ fill: '#3A3A3A' }} d="M77.4,49.4l-6.6-26.6c-0.6,0.8-1.5,1.4-2.5,1.6l4.2,25L77.4,49.4z" />
          <path
            style={{ fill: '#484848' }}
            d="M70,20.3c0-0.1,0-0.3,0-0.4l-0.1-0.4c-0.5-1.4-2-2.1-3.4-1.7c-1.4,0.5-2.1,2-1.7,3.4
		c0.5,1.4,2,2.1,3.4,1.7C69.3,22.5,70,21.5,70,20.3L70,20.3z"
          />
          <path
            style={{ fill: '#484848' }}
            d="M43.3,36.4v4.8c0,1.9-1.5,3.4-3.4,3.4h-5.2c-1.9,0-3.4-1.5-3.4-3.4v-5h-7.7c-0.9,0-1.7,0.8-1.7,1.7
		v11.5h35.6v-9.1c0-1-0.7-1.8-1.6-1.9L43.3,36.4z"
          />
          <path style={{ fill: '#3A3A3A' }} d="M63,20.7L48.2,35.6l6.5,1.1l11-12.5C64.3,23.7,63.2,22.3,63,20.7z" />
          <path
            style={{ fill: '#484848' }}
            d="M21,55.1h37.8v-4.9c0-0.6-0.5-1.1-1.1-1.1h0H22.1c-0.6,0-1.1,0.5-1.1,1.1l0,0V55.1z"
          />
          <path
            style={{ fill: '#3A3A3A' }}
            d="M40.2,18.9H23.4c-0.8-0.1-1.5,0.5-1.6,1.3v2.1c0.1,0.8,0.8,1.4,1.6,1.3h16.8
		c0.8,0.1,1.5-0.5,1.6-1.3v-2.1C41.7,19.4,41,18.8,40.2,18.9z"
          />
          <path style={{ fill: '#3A3A3A' }} d="M66.1,64.5c6.4-0.4,11.5-5.7,11.5-12.2v-1.2H66.1V64.5z" />
        </g>
        <g
          className={`${name === 'menage' ? classes.show : classes.hide} ${
            disabled ? classes.transparent : classes.opaque
          }`}
        >
          <ellipse style={{ fill: '#EF7E08' }} cx="45" cy="45" rx="45" ry="45" />
          <path
            style={{ fill: '#FBC142' }}
            d="M38.7,22.2h12.9c0.5,0,0.9-0.5,0.9-1c0-0.5-0.4-0.9-0.9-0.9v-5.7c0-0.5-0.4-0.9-0.9-0.9h-11
		c-0.5,0-0.9,0.4-0.9,0.9v5.7c-0.5,0-0.9,0.5-0.9,1C37.8,21.8,38.2,22.2,38.7,22.2L38.7,22.2z"
          />
          <path
            style={{ fill: '#FBC142' }}
            d="M57.3,69.1l-1.8-12c-0.1-0.5-0.5-0.8-0.9-0.8H35.6c-0.5,0-0.9,0.4-0.9,0.9v12c0,0.5,0.4,0.9,0.9,0.9
		c0,0,0,0,0,0h20.8c0.3,0,0.5-0.1,0.7-0.3l0,0C57.3,69.7,57.3,69.4,57.3,69.1L57.3,69.1z"
          />
          <path
            style={{ fill: '#601C70' }}
            d="M61.3,48.7c0-0.6-0.2-1.2-0.6-1.7l-1.1-1.5c-0.2-0.2-0.2-0.4-0.2-0.7c0.1-3.6-0.2-15.2-7.6-20.6
		H38.5c-5.7,4.8-8.9,11.9-8.7,19.4v28.2c0,2.4,1.9,4.3,4.3,4.3h24c2.4,0,4.3-1.9,4.3-4.3c0,0,0,0,0,0v-0.2L61.3,48.7z M49.2,30
		c1.6-0.3,3.1,0.8,3.4,2.4l2.8,15.5c0.3,1.6-0.8,3.1-2.4,3.4c-0.2,0-0.4,0.1-0.5,0.1c-1.4,0-2.7-1-2.9-2.4l-2.8-15.5
		C46.5,31.8,47.6,30.2,49.2,30L49.2,30z M57.1,69.8c-0.2,0.2-0.4,0.3-0.7,0.3H35.6c-0.5,0-0.9-0.4-0.9-0.9v-12
		c0-0.5,0.4-0.9,0.9-0.9h19c0.5,0,0.9,0.3,0.9,0.8l1.8,12C57.4,69.3,57.3,69.6,57.1,69.8L57.1,69.8z"
          />
        </g>
        <g
          className={`${name === 'menage' ? classes.show : classes.hide} ${
            disabled ? `${classes.opaque} disabled` : classes.transparent
          }`}
        >
          <ellipse style={{ fill: '#939393' }} cx="45" cy="45" rx="45" ry="45" />
          <path
            style={{ fill: '#C4C4C4' }}
            d="M38.7,22.2h12.9c0.5,0,0.9-0.5,0.9-1c0-0.5-0.4-0.9-0.9-0.9v-5.7c0-0.5-0.4-0.9-0.9-0.9h-11
		c-0.5,0-0.9,0.4-0.9,0.9v5.7c-0.5,0-0.9,0.5-0.9,1C37.8,21.8,38.2,22.2,38.7,22.2L38.7,22.2z"
          />
          <path
            style={{ fill: '#C4C4C4' }}
            d="M57.3,69.1l-1.8-12c-0.1-0.5-0.5-0.8-0.9-0.8H35.6c-0.5,0-0.9,0.4-0.9,0.9v12c0,0.5,0.4,0.9,0.9,0.9
		c0,0,0,0,0,0h20.8c0.3,0,0.5-0.1,0.7-0.3l0,0C57.3,69.7,57.3,69.4,57.3,69.1L57.3,69.1z"
          />
          <path
            style={{ fill: '#3A3A3A' }}
            d="M61.3,48.7c0-0.6-0.2-1.2-0.6-1.7l-1.1-1.5c-0.2-0.2-0.2-0.4-0.2-0.7c0.1-3.6-0.2-15.2-7.6-20.6
		H38.5c-5.7,4.8-8.9,11.9-8.7,19.4v28.2c0,2.4,1.9,4.3,4.3,4.3h24c2.4,0,4.3-1.9,4.3-4.3c0,0,0,0,0,0v-0.2L61.3,48.7z M49.2,30
		c1.6-0.3,3.1,0.8,3.4,2.4l2.8,15.5c0.3,1.6-0.8,3.1-2.4,3.4c-0.2,0-0.4,0.1-0.5,0.1c-1.4,0-2.7-1-2.9-2.4l-2.8-15.5
		C46.5,31.8,47.6,30.2,49.2,30L49.2,30z M57.1,69.8c-0.2,0.2-0.4,0.3-0.7,0.3H35.6c-0.5,0-0.9-0.4-0.9-0.9v-12
		c0-0.5,0.4-0.9,0.9-0.9h19c0.5,0,0.9,0.3,0.9,0.8l1.8,12C57.4,69.3,57.3,69.6,57.1,69.8L57.1,69.8z"
          />
        </g>
        <g
          className={`${name === 'bio' ? classes.show : classes.hide} ${
            disabled ? classes.transparent : classes.opaque
          }`}
        >
          <g transform="translate(-20.01 -18.74)">
            <circle style={{ fill: '#005CA9' }} cx="65" cy="63.7" r="45" />
            <path
              style={{
                fill: '#C6D86B',
                stroke: '#005CA9',
                strokeWidth: 1.66,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
              }}
              d="M75.6,63.4
			c6.9,9.1,5.2,22.1-3.9,29c-9,6.9-21.9,5.2-28.9-3.7c-7-9.1-5.6-41-5.6-41S68.6,54.4,75.6,63.4z"
            />
            <path
              style={{
                fill: '#C6D86B',
                stroke: '#005CA9',
                strokeWidth: 1.66,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
              }}
              d="M37.3,47.8
			l34.5,44.8l0.1-0.1c9.1-7,10.7-20,3.8-29.1c0,0,0,0,0,0C68.6,54.4,37.3,47.8,37.3,47.8L37.3,47.8z"
            />
            <path
              style={{
                fill: 'none',
                stroke: '#005CA9',
                strokeWidth: 1.66,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
              }}
              d="M44.8,64.1l5.9,1.1
			l0.9-6.4"
            />
            <path
              style={{
                fill: 'none',
                stroke: '#005CA9',
                strokeWidth: 1.66,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
              }}
              d="M52.4,87.3l14-1.5
			l5.6-13.6"
            />
            <path
              style={{
                fill: 'none',
                stroke: '#005CA9',
                strokeWidth: 1.66,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
              }}
              d="M48.9,76.3L59,75.9
			l2.6-9.5"
            />

            <ellipse
              transform="matrix(1.884847e-02 -0.9998 0.9998 1.884847e-02 8.4738 140.0398)"
              style={{ fill: '#005CA9' }}
              cx="75.6"
              cy="65.7"
              rx="17.2"
              ry="16"
            />
            <path
              style={{ fill: '#19926E' }}
              d="M59.6,65.4c-0.2,9.3,6.5,17,15.1,17.5l0.6-34.4c-2.6,0.1-5.1,0.8-7.3,2.1c-0.1,0.2-0.3,0.3-0.4,0.3
			h-0.1C62.6,54.1,59.6,59.5,59.6,65.4z M68.6,55.3c1.7,0,3.1,1.5,3.1,3.2c0,1.7-1.5,3.1-3.2,3.1c-1.7,0-3.1-1.5-3.1-3.2
			C65.5,56.6,66.9,55.2,68.6,55.3C68.6,55.3,68.6,55.3,68.6,55.3z M68.3,68.9c1.7,0,3.1,1.5,3,3.2c0,1.7-1.5,3.1-3.2,3
			s-3.1-1.5-3-3.2c0-0.8,0.4-1.6,1-2.2C66.7,69.2,67.5,68.9,68.3,68.9z"
            />
            <path
              style={{ fill: '#C6D86B' }}
              d="M68,48.5v0.6c5-2.7,11-2.6,15.8,0.3c0-0.2,0-0.4,0-0.6c0.2-4.4-3.2-8.1-7.6-8.3s-8.1,3.2-8.3,7.6
			C67.9,48.2,67.9,48.3,68,48.5L68,48.5z"
            />
            <path
              style={{ fill: '#19926E' }}
              d="M76.6,48.5l-0.6,34.4c8.5-0.2,15.5-7.6,15.7-16.9S85.1,49.1,76.6,48.5z M82.6,75.4
			c1.8,0,3.3-1.5,3.3-3.3c0-1.8-1.5-3.3-3.3-3.3s-3.3,1.5-3.3,3.3C79.3,74,80.8,75.4,82.6,75.4L82.6,75.4z M82.9,61.8
			c1.8,0,3.3-1.5,3.3-3.3c0-1.8-1.5-3.3-3.3-3.3s-3.3,1.5-3.3,3.3C79.6,60.3,81,61.8,82.9,61.8L82.9,61.8z"
            />
            <path
              style={{ fill: '#C6D86B' }}
              d="M82.7,42.3c0.2-6.4,2.6-10.6,4.8-10.5c0.4,0,0.7-0.3,0.7-0.6c0-0.4-0.3-0.7-0.6-0.7
			c-3.1-0.1-5.6,4.6-6,10.8C81.9,41.6,82.3,41.9,82.7,42.3L82.7,42.3z"
            />
            <path
              style={{ fill: '#C6D86B' }}
              d="M65,31.4c2.2,0,4.5,4.3,4.4,10.7c0.4-0.4,0.8-0.7,1.3-1.1c-0.2-6.2-2.6-10.9-5.7-11
			c-0.4,0-0.7,0.2-0.7,0.6c0,0.4,0.2,0.7,0.6,0.7C64.9,31.4,65,31.4,65,31.4L65,31.4z"
            />
          </g>
        </g>
        <g
          className={`${name === 'bio' ? classes.show : classes.hide} ${
            disabled ? `${classes.opaque} disabled` : classes.transparent
          }`}
        >
          <g transform="translate(-20.01 -18.74)">
            <circle style={{ fill: '#494949' }} cx="65" cy="63.7" r="45" />
            <path
              style={{
                fill: '#C7C7C7',
                stroke: '#494949',
                strokeWidth: 1.66,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
              }}
              d="M75.6,63.4
			c6.9,9.1,5.2,22.1-3.9,29c-9,6.9-21.9,5.2-28.9-3.7c-7-9.1-5.6-41-5.6-41S68.6,54.4,75.6,63.4z"
            />
            <path
              style={{
                fill: '#C7C7C7',
                stroke: '#494949',
                strokeWidth: 1.66,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
              }}
              d="M37.3,47.8
			l34.5,44.8l0.1-0.1c9.1-7,10.7-20,3.8-29.1c0,0,0,0,0,0C68.6,54.4,37.3,47.8,37.3,47.8L37.3,47.8z"
            />
            <path
              style={{
                fill: 'none',
                stroke: '#494949',
                strokeWidth: 1.66,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
              }}
              d="M44.8,64.1l5.9,1.1
			l0.9-6.4"
            />
            <path
              style={{
                fill: 'none',
                stroke: '#494949',
                strokeWidth: 1.66,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
              }}
              d="M52.4,87.3l14-1.5
			l5.6-13.6"
            />
            <path
              style={{
                fill: 'none',
                stroke: '#494949',
                strokeWidth: 1.66,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
              }}
              d="M48.9,76.3L59,75.9
			l2.6-9.5"
            />

            <ellipse
              transform="matrix(1.884847e-02 -0.9998 0.9998 1.884847e-02 8.4738 140.0398)"
              style={{ fill: '#494949' }}
              cx="75.6"
              cy="65.7"
              rx="17.2"
              ry="16"
            />
            <path
              style={{ fill: '#6A6A6A' }}
              d="M59.6,65.4c-0.2,9.3,6.5,17,15.1,17.5l0.6-34.4c-2.6,0.1-5.1,0.8-7.3,2.1c-0.1,0.2-0.3,0.3-0.4,0.3
			h-0.1C62.6,54.1,59.6,59.5,59.6,65.4z M68.6,55.3c1.7,0,3.1,1.5,3.1,3.2c0,1.7-1.5,3.1-3.2,3.1c-1.7,0-3.1-1.5-3.1-3.2
			C65.5,56.6,66.9,55.2,68.6,55.3C68.6,55.3,68.6,55.3,68.6,55.3z M68.3,68.9c1.7,0,3.1,1.5,3,3.2c0,1.7-1.5,3.1-3.2,3
			s-3.1-1.5-3-3.2c0-0.8,0.4-1.6,1-2.2C66.7,69.2,67.5,68.9,68.3,68.9z"
            />
            <path
              style={{ fill: '#C7C7C7' }}
              d="M68,48.5v0.6c5-2.7,11-2.6,15.8,0.3c0-0.2,0-0.4,0-0.6c0.2-4.4-3.2-8.1-7.6-8.3s-8.1,3.2-8.3,7.6
			C67.9,48.2,67.9,48.3,68,48.5L68,48.5z"
            />
            <path
              style={{ fill: '#6A6A6A' }}
              d="M76.6,48.5l-0.6,34.4c8.5-0.2,15.5-7.6,15.7-16.9S85.1,49.1,76.6,48.5z M82.6,75.4
			c1.8,0,3.3-1.5,3.3-3.3c0-1.8-1.5-3.3-3.3-3.3s-3.3,1.5-3.3,3.3C79.3,74,80.8,75.4,82.6,75.4L82.6,75.4z M82.9,61.8
			c1.8,0,3.3-1.5,3.3-3.3c0-1.8-1.5-3.3-3.3-3.3s-3.3,1.5-3.3,3.3C79.6,60.3,81,61.8,82.9,61.8L82.9,61.8z"
            />
            <path
              style={{ fill: '#C7C7C7' }}
              d="M82.7,42.3c0.2-6.4,2.6-10.6,4.8-10.5c0.4,0,0.7-0.3,0.7-0.6c0-0.4-0.3-0.7-0.6-0.7
			c-3.1-0.1-5.6,4.6-6,10.8C81.9,41.6,82.3,41.9,82.7,42.3L82.7,42.3z"
            />
            <path
              style={{ fill: '#C7C7C7' }}
              d="M65,31.4c2.2,0,4.5,4.3,4.4,10.7c0.4-0.4,0.8-0.7,1.3-1.1c-0.2-6.2-2.6-10.9-5.7-11
			c-0.4,0-0.7,0.2-0.7,0.6c0,0.4,0.2,0.7,0.6,0.7C64.9,31.4,65,31.4,65,31.4L65,31.4z"
            />
          </g>
        </g>
      </svg>
    );
  }
}

Picto.defaultProps = {
  width: 90,
  height: 90,
};

Picto.propTypes = {
  classes: PropTypes.object.isRequired,
  name: PropTypes.oneOf(['foncier', 'matiere', 'energie', 'eau', 'chantier', 'menage', 'bio']),
  disabled: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

export default withStyles(styles)(Picto);
